<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="栏目" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag v-decorator="['informationType']" placeholder="请选择栏目" dictCode="information_type" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="标签关键字" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['tag']" placeholder="请输入标签关键字逗号分隔"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['title']" placeholder="请输入标题"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="图片list" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['picList']" placeholder="请输入缩略图list"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="摘要" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['description']" placeholder="请输入摘要"  ></a-input>
            </a-form-item>
          </a-col>
          <!-- <a-col :span="24">
            <a-form-item label="外部链接" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['outUrl']" placeholder="请输入外部链接"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['type']" placeholder="请输入类型"  ></a-input>
            </a-form-item>
          </a-col> -->
          <a-col :span="24">
            <a-form-item label="正文" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea v-decorator="['content']" rows="4" placeholder="请输入正文" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="文章来源" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['source']" placeholder="请输入文章来源"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="文章作者" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['author']" placeholder="请输入文章作者"  ></a-input>
            </a-form-item>
          </a-col>
          <!-- <a-col :span="24">
            <a-form-item label="是否原创" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['isOriginal']" placeholder="请输入是否原创" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="是否显示" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['isDisplay']" placeholder="请输入是否显示" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="是否置顶" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['isTop']" placeholder="请输入是否置顶" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="推荐" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['isRecommend']" placeholder="请输入推荐" style="width: 100%" />
            </a-form-item>
          </a-col> -->
          <a-col :span="24">
            <a-form-item label="自定义顺序" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['sort']" placeholder="请输入自定义顺序" style="width: 100%" />
            </a-form-item>
          </a-col>
          <!-- <a-col :span="24">
            <a-form-item label="点击次数" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['hit']" placeholder="请输入点击次数" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="点赞次数" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['star']" placeholder="请输入点赞次数" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="发布时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择发布时间" v-decorator="['publishDate']" :trigger-change="true" style="width: 100%" />
            </a-form-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-item label="发布者名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['publishName']" placeholder="请输入发布者名"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="发布者头像" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['publishAvatar']" placeholder="请输入发布者头像"  ></a-input>
            </a-form-item>
          </a-col>
          <!-- <a-col :span="24">
            <a-form-item label="创建人ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['createBy']" placeholder="请输入创建人ID"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="创建时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择创建时间" v-decorator="['createTime']" :trigger-change="true" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="修改人ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['updateBy']" placeholder="请输入修改人ID"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="修改时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择修改时间" v-decorator="['updateTime']" :trigger-change="true" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="删除标识0-正常,1-已删除" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['delFlag']" placeholder="请输入删除标识0-正常,1-已删除" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="Saas码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['sysSign']" placeholder="请输入Saas码"  ></a-input>
            </a-form-item>
          </a-col> -->
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'  

  export default {
    name: 'ElinkxCmsInformationForm',
    components: {
      JFormContainer,
      JDate,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/cms/elinkxCmsInformation/add",
          edit: "/cms/elinkxCmsInformation/edit",
          queryById: "/cms/elinkxCmsInformation/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'informationType','tag','title','picList','description','outUrl','type','content','source','author','isOriginal','isDisplay','isTop','isRecommend','sort','hit','star','publishDate','publishName','publishAvatar','createBy','createTime','updateBy','updateTime','delFlag','sysSign'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'informationType','tag','title','picList','description','outUrl','type','content','source','author','isOriginal','isDisplay','isTop','isRecommend','sort','hit','star','publishDate','publishName','publishAvatar','createBy','createTime','updateBy','updateTime','delFlag','sysSign'))
      },
    }
  }
</script>